import signUp from './signUp'
import confirmEmail from './confirmEmail'
import forgotPassword from './forgotPassword'
import resetPassword from './resetPassword'
import finishRegistration from './finishRegistration'

const namespaced = true

export default {
  namespaced,
  modules: {
    signUp,
    confirmEmail,
    forgotPassword,
    resetPassword,
    finishRegistration
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/register/forms/index.js